import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { routingProfileServiceEnvironment } from '../routing-profile-service-environment';
import { routingProfileSchema } from '../schemas/routing-profile.schema';

/**
 * Get an existing Routing Profile by its name
 * @param name Name of the Routing Profile
 * @returns The Routing Profile
 */
export function getRoutingProfilesName(this: unknown, name: string) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${
          routingProfileServiceEnvironment.resolve(this).routingProfilesNameUrl
        }/${encodeURIComponent(name)}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        message: z.string(),
        data: routingProfileSchema,
      })
    )
  );
}
